var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1467 2.0008C12.9548 2.00969 12.7794 2.11306 12.6768 2.27539L5.62114 13.4523C5.3738 13.8428 5.65291 14.353 6.11519 14.3554H10.7753L10.2364 21.3685C10.1932 21.9756 10.9875 22.2406 11.3176 21.7292L18.3789 10.5512C18.6276 10.1584 18.344 9.64591 17.8791 9.64809H13.2202L13.7625 2.635C13.7906 2.28109 13.5013 1.9825 13.1467 2.0008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergy);
export default __webpack_public_path__ + "static/media/icon-energy.824523187768a8bb7c67f91f0e42c0d6.svg";
export { ForwardRef as ReactComponent };